<template>
  <material-card
    :title="$t('components.claims.claim_filters')"
    icon="description"
  >
    <v-card-text>
      <v-form>
        <v-container fluid>
          <v-row>
            <v-col xs="12" sm="6" md="4" lg="3">
              <trans-multi-select2
                v-model="filters.Plan.value"
                :items="plans"
                :label="$t('globals.plan')"
                field="Name"
                itemValue="Id"
              ></trans-multi-select2>
            </v-col>
            <v-col xs="12" sm="6" md="3" lg="2">
              <pbas-date-picker
                :label="$t('headers.claim_submissions.date_submitted')"
                :value="filters.DateSubmitted.value"
                @update-date="updateDate"
              ></pbas-date-picker>
            </v-col>
            <v-col xs="12" sm="6" md="1" lg="1">
              <v-autocomplete
                :clearable="true"
                :label="$t('headers.claim_submissions.date_submitted_operator')"
                v-model="filters.DateSubmitted.operator"
                clear-icon="clear"
                :items="operators"
              ></v-autocomplete>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <no-autocomplete-textfield
                v-model="filters.SubmissionId.value"
                :label="$t('components.claims_history.header.submission_id')"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <no-autocomplete-textfield
                v-model="filters.CertificateNumber.value"
                :label="$t('headers.claim_submissions.certificate_number')"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <no-autocomplete-textfield
                v-model="filters.LastName.value"
                :label="$t('globals.lastname')"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <no-autocomplete-textfield
                v-model="filters.FirstName.value"
                :label="$t('globals.firstname')"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col xs="12" sm="6" md="3" lg="2">
              <currency-textfield
                v-model="filters.AmountRequested.value"
                :label="$t('headers.claim_submissions.amount_requested')"
              />
            </v-col>
            <v-col xs="12" sm="6" md="1" lg="1">
              <v-autocomplete
                :clearable="true"
                :label="
                  $t('headers.claim_submissions.amount_requested_operator')
                "
                v-model="filters.AmountRequested.operator"
                clear-icon="clear"
                :items="operators"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="apply" :disabled="disabled" color="primary">
        {{ $t("globals.apply") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import TransMultiSelect2 from "@/components/TransMultiSelect2";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import ErrorHandler from "@/components/ErrorHandler";
import CurrencyTextfield from "@/components/CurrencyTextfield.vue";
export default {
  components: {
    ErrorHandler,
    TransMultiSelect2,
    NoAutocompleteTextfield,
    CurrencyTextfield,
  },
  data() {
    return {
      error: null,
      filters: {
        Plan: {
          type: "plans-select",
          column: "PlanNumber",
          historyColumn: "PlanNumber",
        },
        DateSubmitted: { type: "date", column: "CreatedOn" },
        SubmissionId: { type: "string", column: "Submissionid" },
        CertificateNumber: {
          type: "string",
          column: "StudentId",
          historyColumn: "StudentNumber",
        },
        LastName: { type: "string", column: "LastName" },
        FirstName: { type: "string", column: "FirstName" },
        AmountRequested: {
          type: "decimal",
          column: "ClaimAmountTotal",
          historyColumn: "TotalSubmitted",
        },
      },
      currentFilter: null,
      newFilter: null,
      currentHistoryFilter: null,
      newHistoryFilter: null,
      operators: ["=", ">", "<"],
      plans: [],
    };
  },
  computed: {
    disabled() {
      console.log("disabled: ", this.currentFilter, this.newFilter);
      return this.currentFilter === this.newFilter;
    },
  },
  async mounted() {
    const plans = (await this.getUserPlans()).data.value;
    this.plans = plans.map((o) => {
      o.Name = o.Current.Name;
      o.Description = o.Current.Description;
      o.Translations = o.Current.Translations;
      return o;
    });
    console.log(this.plans);
  },
  watch: {
    filters: {
      handler(v) {
        this.createFilters();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions("plansMembers", ["getUserPlans"]),
    apply() {
      this.currentFilter = this.newFilter;
      this.currentHistoryFilter = this.newHistoryFilter;
      this.$emit("filter", {
        claimsQuery: this.currentFilter,
        historyQuery: this.currentHistoryFilter,
      });
    },
    createFilters() {
      console.log(this.filters);
      let filtersList = [];
      let historyFiltersList = [];
      for (let key of Object.keys(this.filters)) {
        if (
          this.filters[key].value !== null &&
          this.filters[key].value !== undefined &&
          this.filters[key].value !== ""
        ) {
          let filter = this.createFilter(this.filters[key]);
          console.log(filter);
          if (filter !== null) {
            filtersList.push(filter);
          }
          if (this.filters[key].historyColumn !== undefined) {
            filter = this.createHistoryFilter(this.filters[key]);
            if (filter !== null) {
              historyFiltersList.push(filter);
            }
          }
        }
      }
      console.log(filtersList);
      if (filtersList.length > 0) {
        this.newFilter = filtersList.join(" and ");
      } else {
        this.newFilter = null;
      }
      console.log(historyFiltersList);
      if (historyFiltersList.length > 0) {
        this.newHistoryFilter = historyFiltersList.join(" and ");
      } else {
        this.newHistoryFilter = null;
      }

      console.log(this.newFilter, this.newHistoryFilter);
    },
    createFilter(filter) {
      switch (filter.type) {
        case "string": {
          return this.createStringFilter(filter);
        }
        case "date": {
          return this.createDateFilter(filter);
        }
        case "decimal": {
          return this.createDecimalFilter(filter);
        }
        case "plans-select": {
          return this.createPlansSelectFilter(filter);
        }
        default: {
          throw new Error("Filter type not found");
        }
      }
    },
    createStringFilter(filter) {
      // console.log(filter);
      return `contains(tolower(${filter.column}), '${this.escapeValue(
        filter.value.toLowerCase()
      )}')`;
    },
    createDateFilter(filter) {
      console.log(filter.operator);
      switch (filter.operator) {
        case "=": {
          return `date(${filter.column}) eq ${
            this.escapeValue(filter.value).split("T")[0]
          }`;
        }
        case ">": {
          return `date(${filter.column}) gt ${
            this.escapeValue(filter.value).split("T")[0]
          }`;
        }
        case "<": {
          return `date(${filter.column}) lt ${
            this.escapeValue(filter.value).split("T")[0]
          }`;
        }
        default: {
          return null;
        }
      }
    },
    createDecimalFilter(filter) {
      switch (filter.operator) {
        case "=": {
          return `${filter.column} eq ${this.escapeValue(filter.value)}`;
        }
        case ">": {
          return `${filter.column} gt ${this.escapeValue(filter.value)}`;
        }
        case "<": {
          return `${filter.column} lt ${this.escapeValue(filter.value)}`;
        }
        default: {
          return null;
        }
      }
    },
    createPlansSelectFilter(filter) {
      // console.log(filter);
      let list = [];
      for (let value of filter.value) {
        list.push(
          `tolower(${filter.column}) eq '${this.escapeValue(
            value.UniqueIdentifier.toLowerCase()
          )}'`
        );
      }
      return `(${list.join(" or ")})`;
    },
    createHistoryFilter(filter) {
      switch (filter.type) {
        case "string": {
          return this.createHistoryStringFilter(filter);
        }
        case "date": {
          return this.createHistoryDateFilter(filter);
        }
        case "decimal": {
          return this.createHistoryDecimalFilter(filter);
        }
        case "plans-select": {
          return this.createPlansSelectHistoryFilter(filter);
        }
        default: {
          throw new Error("Filter type not found");
        }
      }
    },
    createHistoryStringFilter(filter) {
      return `contains(tolower(${filter.historyColumn}), '${this.escapeValue(
        filter.value.toLowerCase()
      )}')`;
    },
    createHistoryDateFilter(filter) {
      switch (filter.operator) {
        case "=": {
          return `date(${filter.historyColumn}) eq ${
            this.escapeValue(filter.value).split("T")[0]
          }`;
        }
        case ">": {
          return `date(${filter.historyColumn}) gt ${
            this.escapeValue(filter.value).split("T")[0]
          }`;
        }
        case "<": {
          return `date(${filter.historyColumn}) lt ${
            this.escapeValue(filter.value).split("T")[0]
          }`;
        }
      }
    },
    createHistoryDecimalFilter(filter) {
      switch (filter.operator) {
        case "=": {
          return `${filter.historyColumn} eq ${this.escapeValue(filter.value)}`;
        }
        case ">": {
          return `${filter.historyColumn} gt ${this.escapeValue(filter.value)}`;
        }
        case "<": {
          return `${filter.historyColumn} lt ${this.escapeValue(filter.value)}`;
        }
      }
    },
    createPlansSelectHistoryFilter(filter) {
      console.log(filter);
      let list = [];
      for (let value of filter.value) {
        list.push(
          `tolower(${filter.historyColumn}) eq '${this.escapeValue(
            value.UniqueIdentifier.toLowerCase()
          )}'`
        );
      }
      return `(${list.join(" or ")})`;
    },
    escapeValue(value) {
      if (value instanceof Date) {
        return value.toISOString();
      }
      return encodeURI(value.replace(/\'/g, "''"));
    },
    updateDate(val) {
      this.filters.DateSubmitted.value = val;
      this.$forceUpdate();
      this.createFilters();
    },
  },
};
</script>
